import React from 'react'

import { Image, Container, Header } from 'semantic-ui-react';
import PlaceholderCardImage from './../../../../drive/PlaceHolder/PlaceHolderCard'
import InitiativeContent from './EventStream/initiativeCard';
import PlaybookContent from './EventStream/PlaybookCard';
import ContentCard from './EventStream/ContentCard';
import CommunityCard from './EventStream/CommunityCard';
import { dispatch } from '@rematch/core';
import noEventImage from './../../../../../images/grafix-banner/gfx-no-events-stream.svg'
import LoadingComponent from '../../../../common/LoadingComponent';

class StreamingData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: 10,
            loadingState: false,
            eventType: this.props.show
        };
    }

    componentDidMount() {
        this.refs.iScroll.addEventListener("scroll", () => {
            if (this.refs.iScroll.scrollTop + this.refs.iScroll.clientHeight >= this.refs.iScroll.scrollHeight) {
                this.loadMoreItems();
            }
        });

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.show !== this.props.show) {
            this.refs.iScroll.scrollTop = 0
        }
    }

    loadMoreItems() {
        let eventStreamLength = this.props.eventStreamArray && this.props.eventStreamArray.data && this.props.eventStreamArray.data.length
        if (this.props.eventStreamArray.total !== eventStreamLength) {
            this.setState({ loadingState: true });
            setTimeout(async () => {
                if (this.props.eventPage === "home") {

                    let payload = {
                        name: this.props.filterQuery ? this.props.filterQuery.name : "",
                        serviceName: this.props.filterQuery ? this.props.filterQuery.serviceName : [],
                        sortingType: this.props.filterQuery ? this.props.filterQuery.sortingType : -1,
                        limit: this.state.limit + 5,
                        type: this.props.filterQuery ? this.props.filterQuery.type : "all"
                    }
                    await dispatch.notifications.setFilterQueryData(payload)
                    dispatch.notifications.getEventStreamByOrganization({});
                }
                else if (this.props.eventPage === "organization") {
                    let payL = {
                        limit: this.state.limit + 5,
                        type: this.props.show ? this.props.show : 'all',
                        role: this.props.selectedOrganisation.role
                    }
                    dispatch.notifications.getEventStreamForCommunity(payL);
                }
                else if (this.props.eventPage === 'Team') {
                    let payL = {
                        limit: 50,
                        type: ['practices', 'initiatives', 'contents'],
                        teamId: this.props.match.params.teamId
                    }
                    dispatch.notifications.getEventStreamForTeamId(payL);
                }
                else if (this.props.eventPage === 'User') {
                    let payL = {
                        limit: 50,
                        type: ['practices', 'initiatives', 'contents'],
                        organizationId: this.props.match.params.workspaceId,
                        teamId: this.props.match.params.teamId,
                        userId: this.props.match.params.userId
                    }
                    dispatch.notifications.getEventStreamForUserIdAndTeamId(payL);
                }
                this.setState({ limit: this.state.limit + 5, loadingState: false });
            }, 1000);
        }
    }

    render() {

        const { loaderEventData, selectedOrganisation, eventStreamArray, initiativeOwnerDetails, selectedAccount, noEventDataFound } = this.props

        let windowHeight = window.innerHeight;

        let noEvents = <Container fluid style={{ padding: "70px 0", }} >
            <Image src={noEventImage} size='large' centered={true} style={{ width: "300px" }} className="display-block" />
            <Header as='h5' icon textAlign='center'>
                <Header.Content className="clr-dark-gray" > No events to display!</Header.Content>
            </Header>
        </Container>

        return <div ref="iScroll" style={{ maxHeight: windowHeight - (this.props.eventPage === "home" ? 150 : 160), overflow: "auto", display: "grid" }}>
            {eventStreamArray && eventStreamArray.data && eventStreamArray.data.length > 0 && eventStreamArray.data.map((eventStream, index) => {
                return eventStream.serviceName === "practices" && eventStream.entityData && (this.props.eventPage === "home" ? !eventStream.entityData.playbookUsed : true) ? <PlaybookContent key={index} selectedOrganisation={selectedOrganisation} selectedAccount={selectedAccount} data={eventStream} noEventDataFound={noEventDataFound} currentOrganization={this.props.currentOrganization} user={this.props.user} singlePlaybookEntry={this.props.singlePlaybookEntry} /> :
                    eventStream.serviceName === "initiatives" && eventStream.entityData ? <InitiativeContent key={index} initiativeOwnerDetails={initiativeOwnerDetails} selectedAccount={selectedAccount} selectedOrganisation={selectedOrganisation} data={eventStream} /> :
                        eventStream.serviceName === "contents" && eventStream.entityData ? <ContentCard key={index} selectedOrganisation={selectedOrganisation} selectedAccount={selectedAccount} data={eventStream} /> :
                            (eventStream.serviceName === "suborganizations" || eventStream.serviceName === "organizations") && eventStream.entityData ? <CommunityCard key={index} selectedOrganisation={selectedOrganisation} selectedAccount={selectedAccount} data={eventStream} /> :
                                null
            })}


            {this.state.loadingState || loaderEventData ?
                <div><LoadingComponent active={true}  message="Loading..." /> </div> :
                eventStreamArray && eventStreamArray.data && eventStreamArray.data.length === 0 ?
                    noEvents : null
            }
        </div>
    }
}

export default StreamingData;